"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const styles_1 = __importDefault(require("../../styles/styles"));
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const utils_1 = require("../../utils/utils");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const select_1 = __importDefault(require("../select/select"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const officersSlice_1 = require("../../features/officer/officersSlice");
const ticketUtils_1 = require("../ticketComponent/ticketUtils");
const SchedulesSlice_1 = require("../../features/schedules/SchedulesSlice");
const filterManualConfirmationScheduleConstants_1 = require("./filterManualConfirmationScheduleConstants");
const filterCallRecordConstants_1 = require("../filterCallRecord/filterCallRecordConstants");
const FilterManualConfirmationSchedule = ({ queryParams, setQueryParams, }) => {
    const dispatch = useAppDispatch_1.default();
    const { officer, officers } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        officers: state.officers.officers.data,
    }));
    const [selectedStatus, setSelectedStatus] = react_1.useState();
    react_1.useEffect(() => {
        dispatch(officersSlice_1.getOfficers({}));
    }, []);
    const officerChoices = ticketUtils_1.generateOfficerChoices(officers);
    const onSearch = (input) => ticketUtils_1.searchOfficers(dispatch, input);
    const onSubmit = (payload) => {
        const updatedPayload = {
            ...payload,
            status: selectedStatus,
        };
        dispatch(SchedulesSlice_1.getManualConfirmationSchedules(updatedPayload));
        setQueryParams(updatedPayload);
    };
    const getFieldValue = (field, value) => {
        const formattedField = utils_1.formatTitle(field);
        if (field === 'officerId') {
            const officerMappings = utils_1.mapStatusChoices(officerChoices);
            const label = officerMappings.get(value);
            return [label ? 'Officer' : formattedField, label || value];
        }
        if (field === 'status') {
            const statusMappings = utils_1.mapStatusChoices(filterManualConfirmationScheduleConstants_1.NOT_COMPLETED_STATUSES_CHOICES);
            const label = statusMappings.get(value);
            return [label ? 'Status' : formattedField, label || value];
        }
        if (filterCallRecordConstants_1.FIELD_MAPPING.has(field)) {
            const labelMapping = filterCallRecordConstants_1.FIELD_MAPPING.get(field);
            return [formattedField, labelMapping.get(value) || value];
        }
        return [formattedField, value];
    };
    return (react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground] },
        react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Filters", titleStyle: styles_1.default.textColorBlack }),
        react_1.default.createElement(react_native_paper_1.Card.Content, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] }, Object.entries(queryParams).map(([field, value]) => !utils_1.isEmptyOrUndefined(value) &&
                field !== 'page' &&
                field !== 'officerId' && (react_1.default.createElement(react_native_paper_1.Chip, { key: field, style: [styles_1.default.blueBackground, styles_1.default.marginFive], textStyle: styles_1.default.textColorWhite, mode: "outlined", onClose: () => {
                    setQueryParams({ ...queryParams, [field]: undefined });
                    dispatch(SchedulesSlice_1.getManualConfirmationSchedules({ ...queryParams, [field]: undefined }));
                } }, getFieldValue(field, value).join(' is '))))),
            react_1.default.createElement(formik_1.Formik, { initialValues: queryParams, onSubmit: (values) => onSubmit(values), validateOnChange: false }, ({ handleSubmit, handleChange, values }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] },
                    react_1.default.createElement(react_native_1.View, { style: [{ width: 180 }] },
                        react_1.default.createElement(select_1.default, { value: selectedStatus, setValue: setSelectedStatus, choices: filterManualConfirmationScheduleConstants_1.NOT_COMPLETED_STATUSES_CHOICES, style: { height: 60 } })),
                    officer.is_manager && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.minWidth] },
                        react_1.default.createElement(select_1.default, { value: values.officerId, setValue: () => { }, setValueFormik: handleChange('officerId'), choices: officerChoices, style: [styles_1.default.select, { width: 200 }], searchable: true, onSearch: onSearch })))),
                react_1.default.createElement(react_native_paper_1.Card.Actions, null,
                    react_1.default.createElement(button_1.default, { onPress: handleSubmit, eventName: eventConstants_1.SCHEDULES_FILTER_BUTTON, text: `Filter ` }))))))));
};
exports.default = FilterManualConfirmationSchedule;
